import { useLocation } from '@tanstack/react-router'

/**
 * This hook is used to disable virtualization in the master table by getting parameter from url.
 * @note This solution applicable only for demos/tests/development
 * @returns boolean value to disable virtualization
 */
export const useDisableVirtualization = () => {
	const location = useLocation()

	return Boolean(location.searchStr.includes('disable_virtualization'))
}
